<form [formGroup]="beleggingsrekeningen">
    <div *ngIf="box3Beleggingen.length > 0" class="row">
        <div formArrayName="box3Beleggingen">
            <div *ngFor="let item of box3Beleggingen.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Naam belegging' : ''"
                                                class="custom-input-250 col-auto"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Rekeningnummer' : ''"
                                                class="me-1 custom-input-200 col-auto"
                                                formControlName="rekeningNummer"
                                                id="rekeningNummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Land' : ''"
                                                  [options]="optionsLandcodes"
                                                  [required]=true
                                                  class="custom-input-200 col-auto"
                                                  formControlName="landCode"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? labelJaar : ''"
                                                  [minValue]="0"
                                                  [required]=true
                                                  align="right"
                                                  class="custom-input-150 col-auto"
                                                  formControlName="bedrag"
                                                  id="bedrag"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Groene belegging' : ''"
                                                  [options]="optionsJaNee"
                                                  [required]=true
                                                  class="custom-input-150 col-auto"
                                                  formControlName="groenRekening"
                >
                </snelstart-ui-select-form-control>
                @if (this.incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement) {
                    <snelstart-ui-button
                            (click)="this.showDialog(i)"
                            [class]="i === 0 ? 'me-1 pt-3 custom-input-125' : 'me-1 custom-input-125'"
                            [icon]="heeftOWR[i] ? 'check' : 'plus'"
                            type="secondary">
                        OWR
                    </snelstart-ui-button>
                }
                <snelstart-ui-button (click)="verwijderRijBeleggingsrekeningen(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
                <div style="width: 75%" *ngIf="!this.incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement && box3Beleggingen.controls[i].get('bedrag')?.value == 0">
                    <snelstart-ui-alert
                            class="ps-1"
                            style="color: red" type="danger">
                        Let op! Een belegging met een saldo € 0 levert problemen op bij het indienen van de aangifte.
                        Verwijder daarom deze regel!
                    </snelstart-ui-alert>
                </div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="box3Beleggingen.length === 0">
    <snelstart-ui-button (click)="addRijBeleggingsrekeningen()" class="snelstart-ui-button" icon="plus"
                         type="link">Belegging invullen
    </snelstart-ui-button>
</div>
<div *ngIf="box3Beleggingen.length > 0">
    <snelstart-ui-button (click)="addRijBeleggingsrekeningen()" class="snelstart-ui-button" icon="plus"
                         type="link">Belegging toevoegen
    </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [title]="getOWRDialogTitel(index)"
                                id="owrBeleggingen"
                                size="lg">
    <snelstart-ui-dialog-body>
        <form [formGroup]="beleggingsrekeningen">
            <div *ngIf="box3Beleggingen.length > 0">
                <div formArrayName="box3Beleggingen">
                    <div *ngFor="let item of box3Beleggingen.controls; let i = index; "
                         [formGroupName]="i">
                        <div *ngIf="i === this.index">

                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="labelJaarEind"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="waardeEindJaar"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="labelJaar"
                                                                  [minValue]="0"
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="bedrag"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="stortingen"
                                                                  id="bedrag"
                                                                  label="Aankopen/stortingen"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="onttrekkingen"
                                                                  id="bedrag"
                                                                  label="Verkopen/onttrekkingen"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="directRendement"
                                                                  id="bedrag"
                                                                  label="Bruto dividend/rente"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="valutaResultaat"
                                                                  id="bedrag"
                                                                  label="Valuta koerswinst-/verlies"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            <div class="pt-2">
                                <div class="d-flex align-items-center">
                                    <div class="result-inline">
                                        @let rendement = getBerekendeWerkelijkRendement(i);
                                        Werkelijk rendement in {{ jaar }} =
                                        € {{ rendement != null ? (rendement | number:'1.0-2') : '0' }}
                                    </div>
                                </div>
                                <br/> <br/>
                                {{ getGroen(i) }}
                            </div>
                            <div class="space20"></div>

                            @if (this.box3Beleggingen.controls[i].get('groenRekening')?.value === true) {
                                <snelstart-ui-alert type="warning">
                                    Let op! Als er in de loop van {{ this.jaar }} een groene belegging (effecten of spaartegoed)
                                    is gekocht of verkregen, hoeft het werkelijke rendement hierover nog niet opgenomen
                                    te worden in de aangifte over {{ this.jaar }}.
                                </snelstart-ui-alert>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

